import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import ReactTooltip from "react-tooltip";

import { GetCookie } from "./utils/Common";

import { WorkOrderJobNotesTableReceivables } from "./WorkOrderJobNotesTableReceivables";
import { WorkOrderJobNotesTableNotes } from "./WorkOrderJobNotesTableNotes";

export class WorkOrderJobNotes extends Component {
  static displayName = WorkOrderJobNotes.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      model: props.model,
    };

    this.renderReceivables = this.renderReceivables.bind(this);
    this.renderNotes = this.renderNotes.bind(this);
  }

  componentDidMount() {
    //document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    //document.removeEventListener('keydown', this.keydownHandler);
  }

  renderReceivables() {
    return (
      <WorkOrderJobNotesTableReceivables
        receivableList={this.props.receivableList}
      />
    );
  }

  renderNotes() {
    return (
      <WorkOrderJobNotesTableNotes
        receivableItemList={this.props.receivableItemList}
      />
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modal}
        toggle={this.props.setModal}
        style={{ width: "1024px" }}
        backdrop="static"
      >
        <ModalHeader>
          <span style={{ fontSize: "18px" }}>Job Notes</span>
        </ModalHeader>
        <ModalBody>
          <div>
            <Row>
              <Col>
                <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Receivables
                </span>
              </Col>
            </Row>
            <Row>
              <Col
                className=" x-panel-body x-layout-fit x-panel-body-default"
                style={{
                  overflowY: "scroll",
                  height: "200px",
                  backgroundColor: "unset",
                  width: "100%",
                  marginLeft: "8px",
                  marginRight: "10px",
                }}
              >
                {this.renderReceivables()}
              </Col>
            </Row>
            <Row>
              <Col>
                <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Notes
                </span>
              </Col>
            </Row>
            <Row>
              <Col
                className=" x-panel-body x-layout-fit x-panel-body-default"
                style={{
                  overflowY: "scroll",
                  height: "200px",
                  backgroundColor: "unset",
                  width: "100%",
                  marginLeft: "8px",
                  marginRight: "10px",
                }}
              >
                {this.renderNotes()}
              </Col>
            </Row>
          </div>
          <ReactTooltip id="rtp" place="right" type="dark" effect="solid" />
        </ModalBody>
        {/*<ModalFooter>*/}
        {/*    <Button color="dark" onClick={this.props.setModal} size="sm">Cancel</Button>*/}
        {/*    <Button color="primary" onClick={() => { if (window.confirm("Are you sure to save this record?")) { this.onSave() } }} size="sm">Save</Button>*/}
        {/*</ModalFooter>*/}
      </Modal>
    );
  }
}
